<input type="radio" class="radio-button" name="{{option.name}}" (change)="onOptionSelected(option)" value="{{option.value}}" id="{{option.name}}" />
<label id="label_{{option.name}}" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center option-text"
  [ngClass]="{'option-selected': option.selected}" for="{{option.name}}">
  <span class="svg-icon svg-icon-3x me-5">
    <ng-template svgIconHost></ng-template>
    @if (option.iconType !== 'svg' && option.iconClass) {
      <i class="{{option.iconClass}}"></i>
    }
  </span>
  <span class="d-block fw-bold text-start align-self-center">
    @if (!inEditMode) {
      <span class="text-dark fw-bolder d-block fs-4">{{ getLabel('text') }}</span>
    }
    @if (inEditMode) {
      <input [name]="'option_' + option.name" type="text" class="form-control  form-control-solid fs-2 fw-bolder"
        [ngModel]="i18n.get(option, 'text')"
        (ngModelChange)="i18n.set(option, 'text', $event)"
        [placeholder]="i18n.basePlaceholder(option, 'text')" />
    }
    @if (!inEditMode) {
      <span class="text-gray-400 fw-bold fs-6 mt-2" style="min-height: 60px;">{{ getLabel('explanation') }}</span>
    }
    @if (inEditMode) {
      <input [name]="'option_explanation_' + option.name" type="text"
        class="form-control form-control-solid fs-4 fw-bolder"
        [ngModel]="i18n.get(option, 'explanation')"
        (ngModelChange)="i18n.set(option, 'explanation', $event)"
        [placeholder]="i18n.basePlaceholder(option, 'explanation')" />
    }
  </span>
</label>
